import { locales } from './locales';

const fallbackLocale = 'fr';

const htmlLocale = document.documentElement.lang || fallbackLocale;
const locale = htmlLocale.split('-')[0] || fallbackLocale;
const numberFormats = {
  fr: {
    currency: {
      style: 'currency',
      currency: 'EUR',
    },
    percent: {
      style: 'percent',
      signDisplay: 'always',
    },
  },
};

export default {
  locale,
  fallbackLocale,
  numberFormats,
  messages: locales,
};
